import {Service} from 'typedi';
import {StrategyBuilder} from '../../StrategyBuilder';
import type {TabsStrategyData} from '../../types/tabsStrategyData';
import {TabsStrategyService} from '../../TabsStrategy';



@Service({id: 'tabsB2cStrategyService'})
export class TabsB2cStrategyServiceBuilder extends StrategyBuilder<TabsStrategyService> {

  build(details:TabsStrategyData): TabsStrategyService {
      return new B2cTabsStrategy(details);
  }
}

export class B2cTabsStrategy extends TabsStrategyService {
  details;

  constructor(details:TabsStrategyData) {
      super();
      this.details = details;
  }

  makeTabs() {
      return 'search-tabs-nav-header-v2';
  }
  getTabProps(params: Record<string, string>): Record<string, string> {
      if (this.details?.params) {
        return this.details.params;
      }
      return {};
  }


}
